import { SpacerProperty as SpaceProp } from '../../peregrineFlowInterfaces';
import { Divider } from '@mui/material';
import { NodePropertyProp } from '../NodePropertyPane';

function SpacerProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as SpaceProp;

    return (
        <Divider textAlign='right' variant="fullWidth" sx={{ marginTop: 2, width: '100%' }}>{p.label}</Divider>
    )
}

export default SpacerProperty;
